import styled, { css } from 'styled-components';
import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';
import colors from 'styles/colors';

export const Container = styled.div`
  padding: 16px;
  background-color: #f3f9fc;
  border: 1px solid #e2e2e3;
  border-radius: 4px;
  display: flex;
  align-items: center;
`;

export const Checkbox = styled(SemanticCheckbox)`
  display: block !important;

  &.ui.checkbox label:before,
  &.ui.checkbox label:hover:before,
  &.ui.checkbox input:checked ~ label:before,
  &.ui.checkbox input:indeterminate ~ label:before {
    border-color: ${colors.grey};
  }

  &.ui.checkbox input:focus ~ label:before,
  &.ui.checkbox input:checked:focus ~ label:before,
  &.ui.checkbox input:indeterminate:focus ~ label:before {
    border-color: ${colors.blue};
  }
`;

export const Column = styled.div<{ size?: 'small' | 'large' }>`
  ${props =>
    props.size &&
    props.size === 'small' &&
    css`
      width: 20%;
      padding-right: 16px;
    `}

  ${props =>
    props.size &&
    props.size === 'large' &&
    css`
      width: 55%;
      padding-left: 16px;
      padding-right: 16px;

      @media screen and (max-width: 600px) {
        width: auto;
        padding-right: 0;
      }
    `}
`;
